/**
 * Dashboard - CountryInfo Store
 *
 * @since 2018-06-08
 * @author ms1124.kim
 *
 */
import Moment from 'moment'
import JSONBigInt from 'json-bigint'

// Prefix
const dashApiPath = '/api/lr/dashboard'
const basicDateFormat = 'YYYY-MM-DD HH:mm:ss'

export const state = () => ({})

export const mutations = {}
export const actions = {
  async getCountryInfoData (store, { widgetType, filters, timeRange = 1440, topN = 50, sTime = null, eTime = null }) {
    // 공통 리턴 포맷
    const res = {
      code: 'ok',
      eTime: '',
      result: ''
    }

    // 공통변수 선언
    let endTime = null
    let startTime = null
    let devBaseTime = null

    // 장비시간 가져오기
    const deviceTime = this.getters['common/common/getDeviceTime']

    // 위젯에서 sTime과 eTime을 계산하지 않는 경우 (TopN 데이터, 통계 데이터를 기준으로 하는 추이 데이터)
    if (sTime === null || eTime === null) {
      // 장비 시간에서 3분을 뺀 시간을 기준으로 잡는다. (통계 데이터 쌓는 시간 기준)
      devBaseTime = Moment(deviceTime).subtract(3, 'minutes')

      // timeRange가 1이상 일 경우 1시간 기준 데이터 (초단위 00 ~ 59 초기화)
      const calcBaseTime = _.cloneDeep(devBaseTime)

      // startTime = devBaseTime - timeRange시간 + 초 00으로 초기화
      startTime = calcBaseTime.subtract(timeRange, 'minutes').startOf('minutes').format(basicDateFormat)

      // eTime = calcBaseTime - 1초
      endTime = Moment(devBaseTime).startOf('minutes').subtract(1, 'seconds').format(basicDateFormat)
    } else {
      // 위젯에서 계산해서 들어오는 경우 - 실시간 위젯
      endTime = eTime
      startTime = sTime
    }

    try {
      // TAMS (POST)
      const {code, result} = await this.$axios.$post(dashApiPath, {
        top: topN,
        type: widgetType,
        etime: endTime,
        stime: startTime,
        filters: filters // TAMS
      }, {
        loading: false,
        successAlert: false,
        transformResponse: [
          (data) => {
            return JSONBigInt.parse(data)
          }
        ]
      })

      res.eTime = endTime

      if (code === 'ok') {
        res.result = result || {
          result: [],
          unit_time: ''
        }
      }

      return res
    } catch (e) {
      res.code = 'nok'
      res.reason = e

      return res
    }
  }
}
export const getters = {}
export const strict = false
